

// // Register.jsx
// import React, { useState } from 'react';
// import { Input, Button, Form,  Tooltip } from 'antd';
// import { 
//   UserOutlined, 
//   LockOutlined, 
//   KeyOutlined, 
//   QuestionCircleOutlined,
// } from '@ant-design/icons';
// import { useNavigate } from 'react-router-dom';
// import { ToastContainer, toast } from 'react-toastify';
// import axios from '../components/Axios';
// import './Register.css';

// function Register() {
//   const [form] = Form.useForm();
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

//   const handleSubmit = async (values) => {
//     setLoading(true);
//     try {
//       const response = await axios.post('/auth/register', values);
      
//       if (response.data) {
//         toast.success('🎉 Registration successful! Redirecting to login...', {
//           position: "top-right",
//           autoClose: 2000,
//           hideProgressBar: false,
//         });
//           localStorage.setItem('showRefreshHint', 'true');

//         setTimeout(() => navigate('/login'), 2000);
//       }
//     } catch (error) {
//       const errorMessage = error.response?.data?.error || 'Registration failed. Please try again.';
//       toast.error(`😕 ${errorMessage}`, {
//         position: "top-right",
//         autoClose: 5000
//       });
//     } finally {
//       setLoading(false);
//     }
//   };



//   return (
//     <div className="register-wrapper">
//       <div className="register-container">
//         <div className="register-left">
     
//           <div className="left-content">
//   <h2>You're One Step From Free Quora Traffic</h2>
//   <div className="features-list">
//     <div className="feature-item">
//       <div className="feature-icon">🔍</div>
//       <div className="feature-text">
//         <h4>Find Questions That Already Get Traffic</h4>
//         <p>Scrape Quora by real views, upvotes & answer count — go where readers already are.</p>
//       </div>
//     </div>
//     <div className="feature-item">
//       <div className="feature-icon">🤖</div>
//       <div className="feature-text">
//         <h4>Answers Written In Your Voice</h4>
//         <p>Multiple AI models draft helpful, on-brand answers — you review, then publish.</p>
//       </div>
//     </div>
//     <div className="feature-item">
//       <div className="feature-icon">▶️</div>
//       <div className="feature-text">
//         <h4>Get Your Videos Watched</h4>
//         <p>YouTube mode embeds your video right inside the answer — views without the click-away.</p>
//       </div>
//     </div>
//   </div>
// </div>
//         </div>

//         <div className="register-right">
//           <div className="register-box">
//             <div className="register-header">
//               <h1>Create Your Account</h1>
//             </div>

//             <Form
//               form={form}
//               name="register"
//               onFinish={handleSubmit}
//               layout="vertical"
//               className="register-form"
//             >
//               <Form.Item
//                 name="email"
//                 rules={[
//                   { required: true, message: 'Please input your email!' },
//                   { type: 'email', message: 'Please enter a valid email!' }
//                 ]}
//               >
//                 <Input
//                   size="large"
//                   prefix={<UserOutlined className="site-form-item-icon" />}
//                   placeholder="Work email"
//                   className="custom-input"
//                 />
//               </Form.Item>

//               <Form.Item
//                 name="password"
//                 rules={[
//                   { required: true, message: 'Please input your password!' },
//                   { min: 8, message: 'Password must be at least 8 characters!' }
//                 ]}
//                 extra="Must be at least 8 characters long"
//               >
//                 <Input.Password
//                   size="large"
//                   prefix={<LockOutlined className="site-form-item-icon" />}
//                   placeholder="Create password"
//                   className="custom-input"
//                 />
//               </Form.Item>

//               <Form.Item
//                 name="license"
//                 rules={[{ required: true, message: 'Please input your license key!' }]}
//               >
//                 <Input
//                   size="large"
//                   prefix={<KeyOutlined className="site-form-item-icon" />}
//                   placeholder="License key"
//                   className="custom-input"
//                   suffix={
//                     <Tooltip title="Enter the license key you received in your email">
//                       <QuestionCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
//                     </Tooltip>
//                   }
//                 />
//               </Form.Item>

//               <Form.Item>
//                 <Button
//                   type="primary"
//                   size="large"
//                   block
//                   htmlType="submit"
//                   loading={loading}
//                   className="submit-button"
//                 >
//                   {loading ? 'Creating Your Account...' : 'Create Account'}
//                 </Button>
//               </Form.Item>
//             </Form>

//             <div className="login-link">
//               Already have an account?{' '}
//               <span onClick={() => navigate('/login')}>Sign in</span>
//             </div>

//           </div>
//         </div>
//       </div>
//       {/* <ToastContainer /> */}
//     </div>
//   );
// }

// export default Register;








// Register.jsx
import React, { useState } from 'react';
import { Input, Button, Form } from 'antd';
import { 
  UserOutlined, 
  LockOutlined, 
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import axios from '../components/Axios';
import './Register.css';

function Register() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const response = await axios.post('/auth/register', values);
      
      if (response.data) {
        toast.success('🎉 Registration successful! Redirecting to login...', {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
        });
          localStorage.setItem('showRefreshHint', 'true');

        setTimeout(() => navigate('/login'), 2000);
      }
    } catch (error) {
      const errorMessage = error.response?.data?.error || 'Registration failed. Please try again.';
      toast.error(`😕 ${errorMessage}`, {
        position: "top-right",
        autoClose: 5000
      });
    } finally {
      setLoading(false);
    }
  };



  return (
    <div className="register-wrapper">
      <div className="register-container">
        <div className="register-left">
     
          <div className="left-content">
  <h2>You're One Step From Free Quora Traffic</h2>
  <div className="features-list">
    <div className="feature-item">
      <div className="feature-icon">🔍</div>
      <div className="feature-text">
        <h4>Find Questions That Already Get Traffic</h4>
        <p>Scrape Quora by real views, upvotes & answer count — go where readers already are.</p>
      </div>
    </div>
    <div className="feature-item">
      <div className="feature-icon">🤖</div>
      <div className="feature-text">
        <h4>Answers Written In Your Voice</h4>
        <p>Multiple AI models draft helpful, on-brand answers — you review, then publish.</p>
      </div>
    </div>
    <div className="feature-item">
      <div className="feature-icon">▶️</div>
      <div className="feature-text">
        <h4>Get Your Videos Watched</h4>
        <p>YouTube mode embeds your video right inside the answer — views without the click-away.</p>
      </div>
    </div>
  </div>
</div>
        </div>

        <div className="register-right">
          <div className="register-box">
            <div className="register-header">
              <h1>Create Your Account</h1>
            </div>

            <Form
              form={form}
              name="register"
              onFinish={handleSubmit}
              layout="vertical"
              className="register-form"
            >
              <Form.Item
                name="email"
                rules={[
                  { required: true, message: 'Please input your email!' },
                  { type: 'email', message: 'Please enter a valid email!' }
                ]}
              >
                <Input
                  size="large"
                  prefix={<UserOutlined className="site-form-item-icon" />}
                  placeholder="Work email"
                  className="custom-input"
                />
              </Form.Item>

              <Form.Item
                name="password"
                rules={[
                  { required: true, message: 'Please input your password!' },
                  { min: 8, message: 'Password must be at least 8 characters!' }
                ]}
                extra="Must be at least 8 characters long"
              >
                <Input.Password
                  size="large"
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  placeholder="Create password"
                  className="custom-input"
                />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  size="large"
                  block
                  htmlType="submit"
                  loading={loading}
                  className="submit-button"
                >
                  {loading ? 'Creating Your Account...' : 'Create Account'}
                </Button>
              </Form.Item>
            </Form>

            {/* <div className="login-link">
              Already have an account?{' '}
              <span onClick={() => navigate('/login')}>Sign in</span>
            </div> */}

            <div className="login-link">
  Already have an account?{' '}
  <span onClick={() => navigate('/login')}>Login in</span>
  {' '}|{' '}
  <span onClick={() => navigate('/reset-password')}>Forgot password?</span>
</div>

          </div>
        </div>
      </div>
      {/* <ToastContainer /> */}
    </div>
  );
}

export default Register;